export { default, Scorecard } from './Scorecard';
export type { IScorecardAction, IScorecardActions, ScorecardProps } from './types';